import { createAction, props } from '@ngrx/store';
import { IYourSchool } from './your-school.model';

export const loadYourSchool = createAction('[Contacts/API] Load Your School');

export const loadYourSchoolSuccess = createAction(
  '[Contacts/API] Load Your School Success',
  props<{ school: IYourSchool }>()
);
